import React from 'react';
import {AutocompleteChangeReason} from "@mui/material";
import {AutocompleteOption} from "../../../SortFilter/interfaces";
import { FilterAutocomplete } from "../FilterAutocomplete/FilterAutocomplete";

type BoundAutocompleteProps<T> =  {
  options: AutocompleteOption[];
  name: string;
  value?: string | number | null;
  label: string;
  onChange: (newQuery: T) => void;
}

const BoundAutocomplete = <T,>({
  options,
  name,
  value = '',
  label,
  onChange
}: BoundAutocompleteProps<T>) => {

  const handleChange = (_event: React.SyntheticEvent<Element, Event>, newValue: AutocompleteOption, reason: AutocompleteChangeReason) => {
    if (reason !== 'createOption') {
      onChange({
        [name]: newValue?.id ?? ''
      } as unknown as T);
    }
  };

  return (
    <FilterAutocomplete
      label={label}
      value={value}
      options={options}
      onChange={handleChange}
    />
  )
};

export { BoundAutocomplete };